import { useEffect, useState } from 'react'
import { velosterHealthService, VelosterHealthStatus } from '../services/velosterHealthService'
import { useAuthedSocket } from './useAuthedSocket'

interface VelosterHealthEvent {
  level: VelosterHealthStatus['level']
  gpus: VelosterHealthStatus['gpus']
  counts: Record<string, number>
  failureRate: number
  updated_at: string
}

/** Telemetria do Veloster: fetch inicial + updates pelo socket do AI Status, sem polling. */
export function useVelosterHealth(enabled: boolean): VelosterHealthStatus | null {
  const [veloster, setVeloster] = useState<VelosterHealthStatus | null>(null)
  // Em produção, alguns proxies bloqueiam upgrade websocket: inicia por polling.
  const { socket } = useAuthedSocket('/', {
    events: {},
    enabled,
    transports: ['polling', 'websocket'],
  })

  useEffect(() => {
    if (!enabled) return
    let cancelled = false

    velosterHealthService
      .getStatus()
      .then((data) => {
        if (!cancelled) setVeloster(data)
      })
      .catch(() => {
        // sem dados: a tela mostra "Sem dados de telemetria"
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  useEffect(() => {
    if (!enabled || !socket) return
    socket.emit('join_ai_status', {})

    const onUpdate = (payload: VelosterHealthEvent) => {
      setVeloster({
        level: payload.level,
        gpus: payload.gpus,
        counts: payload.counts,
        failureRate: payload.failureRate,
        checkedAt: payload.updated_at,
      })
    }
    socket.on('veloster_health_updated', onUpdate)

    return () => {
      socket.off('veloster_health_updated', onUpdate)
    }
  }, [enabled, socket])

  return veloster
}
